// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Custom scrollbar styles */
.custom-scrollbar::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background-color: rgba(237, 240, 245, 0.5);
  border-radius: 10px;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: rgba(158, 187, 255, 0.6);
  border-radius: 10px;
  -webkit-transition: background-color 0.3s ease;
  transition: background-color 0.3s ease;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: rgba(22, 91, 251, 0.6);
}

/* For Firefox */
.custom-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: rgba(158, 187, 255, 0.6) rgba(237, 240, 245, 0.5);
}

/* When scrollbar is actively being used */
.custom-scrollbar::-webkit-scrollbar-thumb:active {
  background-color: rgba(22, 91, 251, 0.8);
}

/* File Upload Animation */
@keyframes upload-progress {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}

.upload-progress-indicator {
  animation: upload-progress 2s ease-out;
}

/* File attachment styles */
.file-attachment {
  display: flex;
  align-items: center;
  padding: 8px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.file-attachment-icon {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(75, 129, 255, 0.1);
  border-radius: 4px;
}

.file-attachment-details {
  flex-grow: 1;
}

.file-attachment-name {
  font-weight: 500;
  font-size: 14px;
  color: #333;
  margin-bottom: 2px;
}

.file-attachment-size {
  font-size: 12px;
  color: #666;
}
`, "",{"version":3,"sources":["webpack://./src/styles/custom-scrollbar.css"],"names":[],"mappings":";AACA,4BAA4B;AAC5B;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,8CAAsC;EAAtC,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;EACrB,kEAAkE;AACpE;;AAEA,0CAA0C;AAC1C;EACE,wCAAwC;AAC1C;;AAEA,0BAA0B;AAC1B;EACE;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE,sCAAsC;AACxC;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb","sourcesContent":["\n/* Custom scrollbar styles */\n.custom-scrollbar::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-track {\n  background-color: rgba(237, 240, 245, 0.5);\n  border-radius: 10px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb {\n  background-color: rgba(158, 187, 255, 0.6);\n  border-radius: 10px;\n  transition: background-color 0.3s ease;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb:hover {\n  background-color: rgba(22, 91, 251, 0.6);\n}\n\n/* For Firefox */\n.custom-scrollbar {\n  scrollbar-width: thin;\n  scrollbar-color: rgba(158, 187, 255, 0.6) rgba(237, 240, 245, 0.5);\n}\n\n/* When scrollbar is actively being used */\n.custom-scrollbar::-webkit-scrollbar-thumb:active {\n  background-color: rgba(22, 91, 251, 0.8);\n}\n\n/* File Upload Animation */\n@keyframes upload-progress {\n  0% {\n    width: 0%;\n  }\n  100% {\n    width: 100%;\n  }\n}\n\n.upload-progress-indicator {\n  animation: upload-progress 2s ease-out;\n}\n\n/* File attachment styles */\n.file-attachment {\n  display: flex;\n  align-items: center;\n  padding: 8px;\n  background-color: rgba(255, 255, 255, 0.9);\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.file-attachment-icon {\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  margin-right: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(75, 129, 255, 0.1);\n  border-radius: 4px;\n}\n\n.file-attachment-details {\n  flex-grow: 1;\n}\n\n.file-attachment-name {\n  font-weight: 500;\n  font-size: 14px;\n  color: #333;\n  margin-bottom: 2px;\n}\n\n.file-attachment-size {\n  font-size: 12px;\n  color: #666;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
